import { render } from "./PerformancesPage.vue?vue&type=template&id=a755caf8&scoped=true"
const script = {}

import "./PerformancesPage.vue?vue&type=style&index=0&id=a755caf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a755caf8"]])

export default __exports__